export default __webpack_public_path__ + "static/media/ambient-bright-orange-pink.d6e8b74a.jpg";